2783;

/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var _ = require('underscore');
var _get = require('lodash.get');
var moment = require('moment');
var cleanUpResponse = require('common/util/cleanUpResponse');

module.exports = function() {
  var defer = $.Deferred();

  $.soap({
    body: {
      GetAssignedTasks: {
        $xmlns: 'http://dobs.pa.gov/co/task/bpm/1.0'
      }
    },
    blueprintArrays: [
      'GetAssignedTasksResponse.Tasks.NOTF_TASK_INSTANCE',
      'GetAssignedTasksResponse.TaskTypes.CM_LU_TaskType',
      'GetAssignedTasksResponse.Events.CO_Event'
    ],
    blueprint: {
      tasks: [
        '$..NOTF_TASK_INSTANCE',
        {
          taskId: '$..TaskId',
          deliveryDate: '$..DeliveryDate',
          eventId: '$..EventID',
          taskTypeName: '$..TaskTypeName',
          claimedDate: '$..ClaimedDate',
          correspondenceId: '$..CorrespondenceID'
        }
      ],
      taskMetaData: {
        taskTypes: [
          '$..CM_LU_TaskType',
          {
            id: '$.ID',
            name: '$.Name',
            description: '$.Description'
          }
        ],
        events: [
          '$..CO_Event',
          {
            id: '$..ID',
            title: '$..Title',
            startDateTime: '$..StartDateTime',
            createdDate: '$..CreatedDate',
            presenters: '$..EventPresenters'
          }
        ]
      }
    }
  })
    .done(function(response) {
      cleanUpResponse(response);

      _.each(response.tasks, function(task) {
        var eventId = _get(task, 'eventId', {});
        var taskTypeName = _get(task, 'taskTypeName', {});

        var type = _.find(response.taskMetaData.taskTypes, function(type) {
          return taskTypeName === type.name;
        });
        task.taskName = type.description || '--';

        if (eventId) {
          var event = _.find(response.taskMetaData.events, function(event) {
            return eventId === event.id;
          });

          if (event) {
            task.eventName = event.title || '--';
            task.presenters = event.presenters || '--';
            if (event.startDateTime) {
              task.eventDate = moment(event.startDateTime, moment.ISO_8601);
            }
            if (event.createdDate) {
              task.createdDate = moment(event.createdDate, moment.ISO_8601);
            }
          }
        }
      });
      defer.resolve(response.tasks);
    })
    .fail(function(err) {
      defer.reject(err);
    });

  return defer.promise();
};
